import React, { useState, useEffect } from "react";
import { SetHeading } from "../../context/NavbarContext";
import { Breadcrumb, Button, Drawer, Select } from "antd";
import { DoubleRightOutlined, DownloadOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../../src/styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../Routes";
import LoadingSpinner from "../../components/Loading";

import dayjs from "dayjs";
import i18next from "i18next";
import { toast } from "react-toastify";
import DateFilter from "../../components/ui/DateFilter";
import { URLS } from "../../API/API endpoints";
import axiosInstance from "../../AxiosInstance";
import ExportCasInOutReportModal from "../SessionHistory/ExportCasInOutReportModal";
import { GetPaymentMethods } from "../../API  Functions/CashierSetup";
import moment from "moment";
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CustomerCreditOrderTable from "./CustomerCreditOrderTable";
import averageordervalue from "../../assets/Dashboard/averageordervalue.svg";
import creditvalue from "../../assets/Dashboard/creditvalue.svg";
import totalorder from "../../assets/Dashboard/totalorder.svg";
import totalsales from "../../assets/Dashboard/totalsales.svg";
import { getPosOrderLines } from "../../API  Functions/SessionHistoryFunctions";

const CustomerCreditOrder = () => {
    const { t, i18n } = useTranslation();
    const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
    const [loading, setloading] = useState(false);
    const { Option } = Select;
    const [currentLimit, setCurrentLimit] = useState(10); // Default limit
    const [currentOffset, setCurrentOffset] = useState(0); // Default offset
    const [selectedRange, setSelectedRange] = useState("thisMonth");
    const [creditOrderData, setCreditOrderData] = useState([]);
    const today = dayjs();
    const formatToday = today.format("YYYY-MM-DD");
    const startofMonth = today.startOf("month").format("YYYY-MM-DD");
    const [startDate, setStartDate] = useState(startofMonth);
    const [endDate, setEndDate] = useState(formatToday);
    const [exportModalOpen, setExportModalOpen] = useState(false);
    const [allcategory, setAllCategory] = useState([]);
    const [allSubcategory, setAllSubCategory] = useState([]);

    const company_id = useSelector(
        (state) => state?.login?.user?.result?.company_id
    );
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedSubcategory, setSelectedSubcategory] = useState(null);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
    const [customerName, setCustomerName] = useState(""); // To store customer name


    const [visible, setVisible] = useState(false);
    const location = useLocation();


    const [drawerVisible, setDrawerVisible] = useState(false);
    const [drawerLoading, setDrawerLoading] = useState(false);
    const [drawerData, setDrawerData] = useState(null);
    const [orderLines, setOrderLines] = useState([]);



    useEffect(() => {
        // Function to extract query parameter from the URL
        const queryParams = new URLSearchParams(location.search);
        const id = queryParams.get('id');

        if (id) {
            GetCreditData(id, currentOffset, currentLimit); // Pass id into the API call
        }
    }, [location.search, currentOffset, currentLimit]);



    const GetCreditData = async (customer_id, offset, limit) => {
        try {
            // setloading(true);
            const response = await axiosInstance.post(URLS.GET_CUSTOMER_CREDIT_ORDER, {
                company_id: company_id,
                customer_id: Number(customer_id),
                // user_id: user_id,
                offset: offset,
                limit: limit,
                // payment_method: method, //optional
                lang: i18n.language == "ar" ? "ar_001" : "en_US",
            });

            console.log("GetCreditData response", response);

            if (response?.data?.result[0]?.status_code === 200) {
                setCreditOrderData(response?.data?.result[0]);
                const customerName = response?.data?.result[0]?.orders[0]?.customer;
                setCustomerName(customerName);
            } else {
                setCreditOrderData([]);
            }
        } catch (error) {
            console.error("Error fetching KPI data:", error);
            setloading(false);
        } finally {
            setloading(false);
        }
    };




    const handleRowClick = async (order) => {
        setDrawerVisible(true);
        setDrawerLoading(true);
        setDrawerData(order);

        console.log("vdfggv", order);

        try {
            const payload = {
                order_id: order?.order_id,
                lang: i18n.language === "ar" ? "ar_001" : "en_US",
            };
            const res = await getPosOrderLines(payload);

            if (res?.result?.status_code === 200) {
                setOrderLines(res?.result?.records || []);
                console.log("Order Lines Response:", orderLines);
            } else {
                setOrderLines([]);
            }
        } catch (error) {
            console.error("Error fetching order lines:", error);
        } finally {
            setDrawerLoading(false);
        }
    };


    // const handleExport = async (dates) => {
    //     let payload = {
    //         lang: i18next.language === "ar" ? "ar_001" : "en_US",
    //         start_date: dates?.startDate,
    //         end_date: dates?.endDate,
    //         company_id: company_id,
    //     };
    //     const response = await axiosInstance.post(
    //         URLS.INVENTORY_SALE_SUMMARY_EXCEL,
    //         payload
    //     );
    //     console.log("handleExport", response);
    //     if (response?.data?.result?.status_code == 200) {
    //         setExportModalOpen(false);
    //         downloadFile(response?.data?.result?.file_base64);
    //     } else {
    //         toast.error(response?.data?.result.status);
    //     }
    // };

    const downloadFile = (base64Data) => {
        try {
            if (
                !base64Data ||
                typeof base64Data !== "string" ||
                base64Data.trim() === ""
            ) {
                alert("No valid file data available for download");
                return;
            }

            let cleanBase64 = base64Data
                .trim()
                .replace(/^data:[\w/+-]+;base64,/, "")
                .replace(/^["']|["']$/g, "")
                .replace(/\s/g, "");

            const padLength = 4 - (cleanBase64.length % 4);
            if (padLength < 4) cleanBase64 += "=".repeat(padLength);

            let binaryString = atob(cleanBase64);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }

            const header = new Uint8Array(bytes.buffer, 0, 8);
            let mimeType = "application/octet-stream";
            let fileExtension = "bin";

            if (header[0] === 0x50 && header[1] === 0x4b) {
                mimeType =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                fileExtension = "xlsx";
            } else if (
                header[0] === 0xd0 &&
                header[1] === 0xcf &&
                header[2] === 0x11 &&
                header[3] === 0xe0
            ) {
                mimeType = "application/vnd.ms-excel";
                fileExtension = "xls";
            } else if (new TextDecoder().decode(header).includes(",")) {
                mimeType = "text/csv";
                fileExtension = "csv";
            }

            const blob = new Blob([bytes], { type: mimeType });
            const timestamp = moment().format('YYYY-MM-DD_HH.mm.ss'); // Using period for time
            const filename = `${t('category_wise_sale_summary')}_${timestamp}.${fileExtension}`;

            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            }, 100);
        } catch (error) {
            console.error("File download failed:", error);
            alert(`Download failed: ${error.message || "Unknown error"}`);
        }
    };




    const onClose = () => {
        setVisible(false);
    };

    const onDrawerClose = () => {
        setDrawerVisible(false);
        setOrderLines([]);
    };


    const values = [
        {
            img: totalsales,
            heading: t("Total Credit"),
            productsleft: `${t("EGP")} ${creditOrderData?.summary?.total_credit
                ? creditOrderData?.summary?.total_credit?.toFixed(2)
                : "0"
                }`,
            bgcolor: "#2F80ED29",
            textcolor: "#2F80ED",
        },
        {
            img: totalorder,
            heading: t("Amount Paid"),
            // productsleft: creditOrderData?.summary?.amount_paid || "0",
            productsleft: `${t("EGP")} ${creditOrderData?.summary?.amount_paid
                ? creditOrderData?.summary?.amount_paid?.toFixed(2)
                : "0"
                }`,
            bgcolor: "#DBFBDA6B",
            textcolor: "#059003",
        },
        {
            img: creditvalue,
            heading: t("Remaining Balance"),
            productsleft: `${t("EGP")} ${creditOrderData?.summary?.balance
                ? creditOrderData?.summary?.balance?.toFixed(2)
                : "0"
                }`,
            bgcolor: "#EB575729",
            textcolor: "#EB5757",
            //   wide: true,
        },
    ];



    return (
        <>
            <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto  bg-[#F6F7F9]">
                <SetHeading value="Customer Credit Orders" />
                <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ms-3 mt-4">
                    <div className="font-extrabold mb-3">
                        <Breadcrumb
                            separator={<DoubleRightOutlined />}
                            items={[
                                {
                                    title: <Link to={routes.credithistory}>{t("Credit History")}</Link>,
                                    key: "credithistory",
                                },
                                {
                                    title: <span className="text-primaryBlue" >{customerName || t("Customer Credit Orders")}</span>, // Use customerName if available
                                },
                                // { title: t("Customer Credit Orders") },
                            ]}
                            className="relative mt-3 font-semibold"
                        />
                    </div>
                    <div
                        className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 xl:grid-cols-3 me-4 mt-4`}
                    >
                        {Object.values(values).map((val, index) => (
                            <div
                                key={index}
                                className={`rounded-xl px-5 py-4 shadow-sm transition-transform transform ${val.wide ? "col-span-2" : ""
                                    }`}
                                style={{ backgroundColor: val.bgcolor }}
                                onClick={val.action}
                            >
                                <div className="flex items-center justify-between gap-3">
                                    <div className="flex items-center gap-3">
                                        <img src={val.img} alt="icon" className="w-10 h-10" />
                                        <div className="flex flex-col">
                                            <p className="text-sm font-medium text-gray-700 truncate">
                                                {val.heading}
                                            </p>

                                            <p
                                                className="text-xl font-bold"
                                                style={{ color: val.textcolor }}
                                            >
                                                {val.productsleft}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className=" mt-3">
                        <div className="flex items-center">

                            {/* 
                            <div className=" mb-2 ms-3">
                                <DateFilter
                                    setSelectedRange={setSelectedRange}
                                    selectedRange={selectedRange}
                                    SubmitFilter={(start, end) => {
                                        setloading(true)
                                        setStartDate(start);
                                        setEndDate(end);
                                        setSelectedCategory(null);
                                        setSelectedSubcategory(null);
                                        setSelectedPaymentMethod('');
                                        setCurrentLimit(10);
                                        setCurrentOffset(0);
                                        GetCreditData(null, '', start, end, 0, 10); // Fetch all products
                                    }}
                                />
                            </div>  */}
                        </div>
                        <div className=" flex justify-end mt-3 mx-8">
                            {/* <button
                                className="w-48 h-10 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
                                onClick={() => setExportModalOpen(true)}
                            >
                                <DownloadOutlined
                                    style={{ fontSize: "1.5em", MozMarginStart: -10 }}
                                />

                                <span>{t("Download in Excel")}</span>
                            </button> */}
                        </div>
                        {loading ? (
                            <ShimmerLoader />
                        ) : (
                            <>
                                <CustomerCreditOrderTable
                                    additionalData={creditOrderData?.orders}
                                    pagination={(values) => {
                                        setCurrentLimit(values.limit);
                                        setCurrentOffset(values.offset);
                                    }}
                                    onRowClick={handleRowClick}
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Drawer */}
            <Drawer
                title={
                    drawerData
                        ? `Receipt No. ${drawerData.receipt_no}`
                        : t("Order Details")
                }
                placement={i18n.language === "ar" ? "left" : "right"}
                width={500}
                onClose={onDrawerClose}
                visible={drawerVisible}
                styles={{
                    header: {
                        color: "#1E3ABA", // Change this to your desired color
                        fontWeight: "bold",
                        fontSize: "20px",
                    },
                }}
            >
                {drawerLoading ? (
                    <div className="space-y-4 p-4">
                        {/* Header Skeleton */}
                        <div className="h-6 bg-gray-200 rounded animate-pulse w-1/2"></div>

                        {/* Summary Skeleton */}
                        <div className="space-y-2">
                            <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4"></div>
                            <div className="h-4 bg-gray-200 rounded animate-pulse w-2/3"></div>
                            <div className="h-4 bg-gray-200 rounded animate-pulse w-1/2"></div>
                        </div>

                        {/* Product Line Skeletons */}
                        {[1, 2, 3].map((_, idx) => (
                            <div
                                key={idx}
                                className="flex items-center space-x-3 border rounded-lg bg-white p-3 shadow-sm animate-pulse"
                            >
                                <div className="w-10 h-10 bg-gray-200 rounded"></div>
                                <div className="flex-1 space-y-2">
                                    <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                                    <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                                </div>
                                <div className="h-4 bg-gray-200 rounded w-10"></div>
                            </div>
                        ))}
                    </div>
                ) : // <LoadingSpinner />
                    // <div>{t("Loading order details...")}</div>
                    drawerData ? (
                        <div className="space-y-4">
                            {/* Order Summary */}
                            <div className="space-y-1 text-sm font-medium">
                                <p>
                                    <strong>{t("Order Value :")}</strong> {drawerData.currency}{" "}
                                    {drawerData.order_value}
                                </p>
                                <p>
                                    <strong>{t("Total Amount :")}</strong> {drawerData.currency}{" "}
                                    {drawerData.order_value}
                                </p>
                                <p>
                                    <strong>{t("Number of Items :")}</strong> {drawerData.items}
                                </p>
                                <p>
                                    <strong>{t("Payment Mode :")}</strong>{" "}
                                    {drawerData.payment || "-"}
                                </p>
                                <p>
                                    <strong>{t("Payment Status :")}</strong>{" "}
                                    {drawerData.state || "-"}
                                </p>
                            </div>

                            {/* Product Lines */}
                            <div>
                                {orderLines.map((line, index) => (
                                    <div
                                        key={index}
                                        className="flex justify-between items-center border rounded-lg bg-white p-2 mb-2 shadow-sm"
                                    >
                                        {/* Image */}
                                        <img
                                            src={line.image_url || "/placeholder.png"}
                                            alt={line.name}
                                            className="w-10 h-10 object-contain rounded"
                                        />

                                        {/* Middle content: Name + Qty x Price */}
                                        <div className="flex flex-col flex-1 mx-2">
                                            <p className="font-semibold text-sm leading-tight">
                                                {line.name}
                                            </p>
                                            <p className="text-xs text-gray-600">
                                                {line.qty} x {line.price} {line.currency}
                                            </p>
                                        </div>

                                        {/* Right: Total price */}
                                        <p className="font-normal whitespace-nowrap text-right">
                                            {line.currency} {(line.price * line.qty).toFixed(2)}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <p>{t("no_product_found")}</p>
                    )}
            </Drawer>

            {/* {exportModalOpen && (
                <ExportCasInOutReportModal
                    heading={t("Download Category-Wise Sale Summary")}
                    isOpen={exportModalOpen}
                    onClose={() => setExportModalOpen(false)}
                    onExport={(dates) => handleExport(dates)}
                />
            )} */}
        </>
    );
};

export default CustomerCreditOrder;
